export const MATCH_STORAGE_KEY = 'aiscoreboard.matchId';

export function loadStoredMatchId(): string | null {
  return window.localStorage.getItem(MATCH_STORAGE_KEY);
}

export function clearStoredMatchId(): void {
  window.localStorage.removeItem(MATCH_STORAGE_KEY);
}
